import { Pipe, PipeTransform } from '@angular/core';

/// Rounds an hours value for display: at most two decimals, trailing zeros
/// dropped (6.866666 -> 6.87, 13.5 -> 13.5, 8 -> 8). The value itself is never
/// changed - hours are server-computed and the client only shows them.
/// null/undefined/'' pass through as-is, and so does anything non-numeric.
export function formatHours(value: any): any {
  if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) {
    return value;
  }
  const n = Number(value);
  if (!isFinite(n)) {
    return value;
  }
  return String(Math.round((n + Number.EPSILON) * 100) / 100);
}

@Pipe({
  name: 'hours'
})
export class HoursPipe implements PipeTransform {

  transform(value: any): any {
    return formatHours(value);
  }

}
